import { useMutation, useQueryClient } from '@tanstack/react-query';
import {
  ToggleReactionDocument,
  ToggleReactionMutation,
  ToggleReactionMutationVariables,
  ReactionType,
  ReactionParent,
} from '../../../../generated/graphql';
import { communityQueryKeys } from '../constants';
import { toast } from 'react-hot-toast';
import { apolloClient } from '@client/api/graphql/client';
import { updateReactionOnList } from '../utils/toggleReactionHelpers';

export const useToggleReactionReply = (communityId: number | string) => {
  const queryClient = useQueryClient();

  return useMutation<
    { id: string },
    unknown,
    { type: ReactionType; postId: string; replyId: string },
    () => ReactionType
  >({
    // @ts-ignore
    mutationFn: ({ type, replyId }) => {
      const variables: ToggleReactionMutationVariables = {
        communityId: Number(communityId),
        entityId: replyId,
        parent: ReactionParent.Reply,
        type,
      };

      return apolloClient.mutate<
        ToggleReactionMutation,
        ToggleReactionMutationVariables
      >({
        mutation: ToggleReactionDocument,
        variables,
      });
    },
    onMutate: async ({ type, postId, replyId }) => {
      await queryClient.cancelQueries({
        queryKey: communityQueryKeys.postComments(communityId, postId),
      });
      const previousEntities = queryClient.getQueryData(
        communityQueryKeys.postComments(communityId, postId),
      );

      updateReactionOnList({
        entityId: replyId,
        queryClient,
        queryKey: communityQueryKeys.postComments(communityId, postId),
        type,
      });

      return function rollback() {
        queryClient.setQueryData(
          communityQueryKeys.postComments(communityId, postId),
          () => previousEntities,
        );

        return type;
      };
    },
    onSuccess: (data, { postId, replyId }, rollback) => {
      const type = rollback?.();
      if (type) {
        updateReactionOnList({
          entityId: replyId,
          queryClient,
          queryKey: communityQueryKeys.postComments(communityId, postId),
          type,
        });
      }
      // TODO: mixpanel should live here
      // MixpanelHelper.communityEvents.recordReactionAdded({
      //   reactionLocation: commentId ? 'Comment' : 'Post',
      // });
    },
    onError: (_error, _variables, rollback) => {
      rollback?.();
      toast.error('Something went wrong');
    },
  });
};
